var Index = function() {

	if( $('.map').length ){

		google.load("maps", "3", { other_params: 'key=AIzaSyAoH-iZoGdNxQM6137gCV5SEE3N-H5UkuY', callback: initMap } );

		function initMap() {
			var map = new google.maps.Map(document.getElementById('localMap'), {
					center: { lat: -29.6246716, lng: -52.182936 },
					scrollwheel: false,
					zoom: 16
				});
			var marker = new google.maps.Marker({
				position: map.center,
				map: map
			});
		};

	}

	$('.carousel').slick({
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 2,
		dots: true,
		arrows: true,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					arrows: false
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToScroll: 1,
					slidesToShow: 1,
					arrows: false
				}
			}
		]
	});

	$('[data-jump="true"]').smoothScroll({ offset: 0, speed: 'auto' } );
	$('.main-menu .menu-item > a').on('click', function(event) {
		event.preventDefault();
		$('#MenuState').prop('checked', false);
	});

	$(document).on('click', 'a[href*="/trabalho"]', function(e) {

		e.preventDefault();
		var url = $(this).attr('href'),
			tit = $(this).attr('title');

		$.get(url,{ ajax:1 }, function(html) {
			$('.full__modal').html(html);
			$('body').addClass('modal-open');

			var stateObj = { foo: "bar" };
				history.pushState(stateObj, tit, url);
  		});

	});

	$(document).on('click', '.header-modal .btn-close', function(e) {

		$('body').removeClass('modal-open');
		$('.full__modal').html('');

		var stateObj = { foo: "bar" };
			history.pushState(stateObj, '', $(this).data('home'));

	});

	$.addAjaxResponse('formnews', function(json){

		if(json.status == 1) {
			//this é o elemento do formulário
			$(this).removeClass('form-sending').addClass('form-done');
		} else {
			$(this).removeClass('form-sending').addClass('form-error');
		}

	});

	$('form').formProc({

		onStart: function(form) {
			$(form).removeClass('form-error').find('.field-error').removeClass('field-error');
		},
		onError: function(input, form) {
			$(input).closest('.form-group').addClass('field-error');
		},
		onEnd: function(form, valid) {
			if(!valid) {
				$(form).addClass('form-error');
			} else {
				$(form).addClass('form-sending');
			}
		}

	});

};
